
export default {
    data() {
        return {
            nav:0,
            source:'',
            currentPage:1,
            sidebar: 'en'
        }
    },
    mounted() {
        this.parametricWork()
    },
    methods: {
         // 作品方法
         async parametricWork(page = 1) {
                let res = await this.$global.parametricWork({"activityId":13,"page":page,"award":0})
                console.log(res);
                // res.code = '200' ? (this.source = res.result) : []
                this.source = res
            },
            // 分页
            handleCurrentChange(val) {
                this.currentPage = val
                this.parametricWork(this.currentPage)
            },
    },
}
